import React, { createContext, useContext, useState, useEffect } from 'react';
import { RenderTheme, DARK_THEME, LIGHT_THEME } from '../rendering/renderer';
import { settingsRepository } from '../storage/settingsRepository';

interface ThemeContextType {
  themeMode: 'dark' | 'light';
  theme: RenderTheme;
  setThemeMode: (mode: 'dark' | 'light') => void;
}

const ThemeContext = createContext<ThemeContextType>({
  themeMode: 'dark',
  theme: DARK_THEME,
  setThemeMode: () => {},
});

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [themeMode, setThemeModeState] = useState<'dark' | 'light'>('dark');

  useEffect(() => {
    settingsRepository.getSettings().then((settings) => {
      setThemeModeState(settings.theme);
    });
  }, []);

  const setThemeMode = (mode: 'dark' | 'light') => {
    setThemeModeState(mode);
    settingsRepository.setSetting('theme', mode);
  };

  const theme = themeMode === 'dark' ? DARK_THEME : LIGHT_THEME;

  return (
    <ThemeContext.Provider value={{ themeMode, theme, setThemeMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
